import { formatReadableDate } from "utils/formatDate"
import { EmployeeLink } from "../EmployeeLink"
import MetricBadge from "../MetricBadge"

/**
 * Table cell describing a single fuel-usage entry: how much fuel was used,
 * by whom, when, and any remarks. Odometer and derived run/efficiency metrics
 * are presented separately by {@link FuelEfficiencyCell}.
 */
const FuelUsageInfoCell = ({ data = {} }) => {
  const { fuel_qty, remarks, uses_date, fuel_user } = data ?? {}

  const qty = parseFloat(fuel_qty ?? 0)

  return (
    <div className="d-flex flex-column gap-2" style={{ minWidth: 240 }}>
      <MetricBadge
        icon="bx-gas-pump"
        label="Fuel used"
        value={qty > 0 ? `${qty.toFixed(2)} L` : "-"}
        color="danger"
      />

      <div className="small d-flex align-items-center gap-1">
        <i className="bx bx-user text-primary" />
        <span className="text-muted">By</span>
        <EmployeeLink
          name={fuel_user?.name}
          username={fuel_user?.user?.username}
        />
      </div>

      <div className="small d-flex align-items-center gap-1">
        <i className="bx bx-calendar text-info" />
        <span className="text-muted">Used on</span>
        <span className="fw-medium">
          {uses_date ? formatReadableDate(uses_date) : "-"}
        </span>
      </div>

      {remarks ? (
        <div className="small d-flex align-items-start gap-1">
          <i className="bx bx-note text-muted mt-1" />
          <span className="text-muted">{remarks}</span>
        </div>
      ) : null}
    </div>
  )
}

export default FuelUsageInfoCell
